/** Tenant logo shared by both navigation layouts; failed images become neutral icons. */
import { useState } from "react";
import { Building2 } from "lucide-react";
import { brandConfig } from "@/config/brandConfig";
import { useTenantBrand } from "@/hooks/useTenantBrand";

export function TenantLogo({ className }: { className?: string }) {
  const { logoUrl, isLni, displayName } = useTenantBrand();
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  // Only the institutional tenant can inherit the static institutional logo.
  const src = logoUrl?.trim() || (isLni ? brandConfig.logoUrl : null);
  if (!src || failedUrl === src) {
    return <Building2 aria-hidden="true" className={className} />;
  }
  return <img src={src} alt={displayName} className={className} onError={() => setFailedUrl(src)} />;
}